(function () {
  if (window.toggleFeaturedCollectionTab) return;
  window.toggleFeaturedCollectionTab = function toggleFeaturedCollectionTab(tab) {
    const slider = tab.closest(".featured-collection").querySelector(".featured-collection__slider");
    const tabTarget = tab.dataset.tabTarget;
    const sliderItems = slider.querySelectorAll(".featured-collection__slider-item");
    const sliderFlickity = Flickity.data(slider);
    const firstTabSlider = slider.querySelector(`[data-tab="${tabTarget}"]`);
    sliderFlickity.select(parseInt(firstTabSlider.dataset.index) / sliderFlickity.selectedCells.length, true, false);
  };

  function attachSliderToTab() {
    setTimeout(() => {
      const sliders = document.querySelectorAll(".featured-collection__slider--with-tab");
      sliders.forEach(function (slider) {
        const sliderFlickity = Flickity.data(slider);
        if (!sliderFlickity) return console.log("sliderFlickity not found");
        sliderFlickity.on("change", function (index) {
          const sliderItems = slider.querySelectorAll(".featured-collection__slider-item");
          const currentSliderItem = sliderItems[index * sliderFlickity.selectedCells.length];
          const currentTab = currentSliderItem.dataset.tab;
          const tabs = slider.closest(".featured-collection").querySelectorAll(".featured-collection__tabs input");
          tabs.forEach(function (tab) {
            if (tab.dataset.tabTarget === currentTab) {
              tab.checked = true;
            }
          });
        });
      });
    }, 100);
  };
  attachSliderToTab();
  window.addEventListener("flickityScriptLoaded", attachSliderToTab);
})();

